"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startSyntheticsContext = startSyntheticsContext;
const browser_core_1 = require("@datadog/browser-core");
function startSyntheticsContext(hooks) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        if (!(0, browser_core_1.isSyntheticsTest)()) {
            return browser_core_1.SKIPPED;
        }
        const testId = (0, browser_core_1.getSyntheticsTestId)();
        const resultId = (0, browser_core_1.getSyntheticsResultId)();
        return {
            type: eventType,
            session: {
                type: "synthetics" /* SessionType.SYNTHETICS */,
            },
            synthetics: {
                test_id: testId,
                result_id: resultId,
                injected: (0, browser_core_1.willSyntheticsInjectRum)(),
            },
        };
    });
}
//# sourceMappingURL=syntheticsContext.js.map